/**
 * 差异分析引擎 - 终极增强版
 */
export function diffSchemas(local, prod, options = {}) {
  const diffs = [];

  // 1. 扫描 Local 识别：新增表、修改表、重命名、新增/修改字段等
  for (const tableName in local) {
    const localTable = local[tableName];
    const prodTable = prod[tableName];

    if (!prodTable) {
      diffs.push({ table: tableName, op: 'CREATE_TABLE', risk: 'GREEN', new: localTable });
      continue;
    }

    // 表注释
    if (options.cmpComment && localTable.comment !== prodTable.comment) {
      diffs.push({ table: tableName, op: 'MODIFY_TABLE_COMMENT', risk: 'GREEN', from: prodTable.comment, to: localTable.comment });
    }

    // 字段处理 (用于识别 Rename)
    const addedCols = [], droppedCols = [], modifiedCols = [];
    for (const colName in localTable.columns) {
      const localCol = localTable.columns[colName];
      const prodCol = prodTable.columns[colName];
      if (!prodCol) addedCols.push({ name: colName, def: localCol });
      else {
        const changes = [];
        if (localCol.type !== prodCol.type) changes.push({ field: 'type', from: prodCol.type, to: localCol.type });
        if (localCol.nullable !== prodCol.nullable) changes.push({ field: 'nullable', from: prodCol.nullable, to: localCol.nullable });
        if (localCol.defaultValue !== prodCol.defaultValue) changes.push({ field: 'defaultValue', from: prodCol.defaultValue, to: localCol.defaultValue });
        if (options.cmpComment && localCol.comment !== prodCol.comment) changes.push({ field: 'comment', from: prodCol.comment, to: localCol.comment });
        if (changes.length > 0) modifiedCols.push({ name: colName, changes, localCol, prodCol });
      }
    }
    for (const colName in prodTable.columns) {
      if (!localTable.columns[colName]) droppedCols.push({ name: colName, def: prodTable.columns[colName] });
    }

    // 启发式 Rename
    const renames = [];
    const finalAdded = [];
    addedCols.forEach(added => {
      const matchIdx = droppedCols.findIndex(dropped => 
        added.def.type === dropped.def.type && added.def.nullable === dropped.def.nullable && added.def.defaultValue === dropped.def.defaultValue
      );
      if (matchIdx !== -1) {
        const dropped = droppedCols.splice(matchIdx, 1)[0];
        renames.push({ from: dropped.name, to: added.name, def: added.def });
      } else finalAdded.push(added);
    });

    renames.forEach(r => diffs.push({ table: tableName, from: r.from, to: r.to, op: 'RENAME_COLUMN', risk: 'YELLOW', new: r.def }));
    finalAdded.forEach(a => diffs.push({ table: tableName, column: a.name, op: 'ADD_COLUMN', risk: 'GREEN', new: a.def }));
    droppedCols.forEach(d => diffs.push({ table: tableName, column: d.name, op: 'DROP_COLUMN', risk: options.enableRisk ? 'RED' : 'YELLOW', old: d.def }));
    modifiedCols.forEach(m => {
      let risk = 'GREEN';
      if (options.enableRisk) {
        if (m.changes.some(c => c.field === 'type')) risk = 'YELLOW';
        if (m.localCol.nullable === false && m.prodCol.nullable === true && !m.localCol.defaultValue) risk = 'RED';
      }
      diffs.push({ table: tableName, column: m.name, op: 'MODIFY_COLUMN', risk, changes: m.changes, new: m.localCol, old: m.prodCol });
    });

    // 索引处理
    for (const idxName in localTable.indexes) {
      const localIdx = localTable.indexes[idxName];
      const prodIdx = prodTable.indexes[idxName];
      if (!prodIdx) diffs.push({ table: tableName, index: idxName, op: 'ADD_INDEX', risk: 'GREEN', new: localIdx });
      else if (JSON.stringify(localIdx) !== JSON.stringify(prodIdx)) diffs.push({ table: tableName, index: idxName, op: 'MODIFY_INDEX', risk: 'YELLOW', new: localIdx, old: prodIdx });
    }
    for (const idxName in prodTable.indexes) {
      if (!localTable.indexes[idxName]) diffs.push({ table: tableName, index: idxName, op: 'DROP_INDEX', risk: options.enableRisk ? 'YELLOW' : 'GREEN', old: prodTable.indexes[idxName] });
    }

    // 外键处理
    for (const fkName in localTable.foreignKeys) {
      const localFk = localTable.foreignKeys[fkName];
      const prodFk = prodTable.foreignKeys[fkName];
      if (!prodFk) diffs.push({ table: tableName, fk: fkName, op: 'ADD_FK', risk: 'YELLOW', new: localFk });
      else if (JSON.stringify(localFk) !== JSON.stringify(prodFk)) diffs.push({ table: tableName, fk: fkName, op: 'MODIFY_FK', risk: 'RED', new: localFk, old: prodFk });
    }
    for (const fkName in prodTable.foreignKeys) {
      if (!localTable.foreignKeys[fkName]) diffs.push({ table: tableName, fk: fkName, op: 'DROP_FK', risk: options.enableRisk ? 'RED' : 'YELLOW', old: prodTable.foreignKeys[fkName] });
    }
  }

  // 2. 扫描 Prod 识别：被删除的表 (DROP TABLE)
  for (const tableName in prod) {
    if (!local[tableName]) {
      diffs.push({
        table: tableName,
        op: 'DROP_TABLE',
        risk: options.enableRisk ? 'RED' : 'YELLOW',
        old: prod[tableName]
      });
    }
  }

  return diffs;
}
